import { Button, IButtonProps, IconButton } from "@nuorder/components";
import { TargetsQueueType, updateQueueTypeAction } from "actions/collections/collection-target";
import React from "react";
import { Dispatch, connect } from "react-redux";
import { IStore } from "reducers";
import { useTargetWizardContext } from "../../context/target-wizard-context";
import { AllocationBag } from "helpers/allocation-dimension";
import { TARGET_BAG_ID } from "constants/product-collection";

export enum NewTargetButtonType {
    Button = "button",
    Icon = "icon",
}

interface Props {
    children?: React.ReactNode;
    type?: NewTargetButtonType;
}

interface ReduxDispatchProps {
    updateQueueType: (payload: TargetsQueueType) => void;
}

interface ReduxProps {
    targetBag: AllocationBag;
}

const NewTargetWizardButtonComponent = ({
    children,
    updateQueueType,
    targetBag,
    type = NewTargetButtonType.Button,
}: Props & ReduxDispatchProps & ReduxProps) => {
    const {
        actions: { openNewWizard },
    } = useTargetWizardContext();

    const customPropsByType: { [key in NewTargetButtonType]: IButtonProps } = {
        button: {},
        icon: { style: { color: "black" } },
    };

    const componentByType = {
        button: Button,
        icon: IconButton,
    };

    const Component = componentByType[type];

    return (
        <Component
            iconProps={{ iconName: "Add" }}
            onClick={() => {
                updateQueueType(TargetsQueueType.CREATE);
                openNewWizard(targetBag);
            }}
            {...customPropsByType[type]}
        >
            {children}
        </Component>
    );
};

const mapDispatchToProps = (dispatch: Dispatch<IStore>) => {
    return {
        updateQueueType: (payload: TargetsQueueType) => dispatch(updateQueueTypeAction(payload)),
    };
};

const mapStateToProps = (state: IStore) => {
    const targetBag = state.mutate.snapshots.get(TARGET_BAG_ID);

    return {
        targetBag,
    };
};

export const NewTargetWizardButton = connect<ReduxProps, ReduxDispatchProps, Props>(
    mapStateToProps,
    mapDispatchToProps
)(NewTargetWizardButtonComponent);
